import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { AgColor } from '../Styles/AgColor';
import AgTypography from '../Styles/AgTypography';
import { CSSProperties, ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export type AgModalProps = {
  open?: boolean;
  setOpen?: Function,
  body?: ReactNode;
  footer?: ReactNode;
  width?: number;
  customWidth?: string;
  closeIcon?: boolean;
  title?: string | ReactNode;
  state?: string;
  type?:number;
  stateColor?: string;
  bodySX?: CSSProperties;
  footerSX?: CSSProperties;
  onCloseModal?: Function;
  maxHeight?: number | string;
};

export default function AgModal({ open, setOpen, body, footer, width, customWidth, closeIcon, title, state, type, stateColor, bodySX, footerSX, onCloseModal, maxHeight = 600 }: AgModalProps) {
  const handleClose = () => setOpen && setOpen(false);
  const getTitleStyle = useMemo(() => {
    const styles = {
      1: { color: AgColor.grey6, fontSize: '10px', fontWeight: 700 },
      2: { color: AgColor.errorMain, fontSize: '14px', fontWeight: 500 },
      3: { color: AgColor.primaryDark }
    };
    return (type !== undefined) ? (styles?.[type as keyof typeof styles] || {}) : {};
  }, [type]);
  return (
    <div>
      <Modal
        open={!!open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: (width ? `${width}px` : 640),
          minWidth: customWidth ?? 'unset',
          bgcolor: AgColor.grey0,
          boxShadow: 24,
          p: 4,
          borderRadius: '5px',
          display: 'block'
        }}>
          <Box
            sx={{ 
              overflowY: 'auto', 
              maxHeight: maxHeight, 
              marginTop: '16px', 
              '::-webkit-scrollbar': {
                width: '6px'
              },
              '::-webkit-scrollbar-thumb': {
                background: '#e4e2e4',
                borderRadius: '6px',
              },
              ...bodySX
            }}>
            {closeIcon && <CloseIcon onClick={()=>{
              onCloseModal && onCloseModal();
              handleClose();
            }} sx={{ position: 'fixed', right: '16px', top: '16px', cursor: 'pointer' }}/>}
            <>
              {state ? <AgTypography contentStyle={'AP.H3.Medium'} style={{ color: stateColor ?? AgColor.errorMain, marginBottom: '16px' }} component='div'>{state}</AgTypography> : null}
              {(typeof title === 'string' && <AgTypography contentStyle={'AP.H2.Bold'} style={{ ...getTitleStyle, paddingBottom: '15px' }} component='div'>{title}</AgTypography>) || title}
            </>
            <AgTypography component='div'>
              {body}
            </AgTypography>
          </Box>
          {
            footer ? <Box sx={{ bgcolor: 'white', borderTop: `1px solid ${AgColor.grey3}`, position: 'fixed', bottom: 0, left: 0, right: 0, padding: '16px 48px', height: '80px', display: 'flex', justifyContent: 'end', alignItems: 'center', ...footerSX }}>
              {footer}
            </Box> : null
          }
        </Box>
      </Modal>
    </div>
  );
}